/**
 * Custom Hook for Dashboard Cards Management
 * Manages dashboard cards configuration and data enrichment
 */

import { useMemo } from "react";
import { getDashboardCards } from "../../../config/routes";
import {
  buildEffectiveAccessRights,
  enrichCardsWithData,
} from "../utils";

/**
 * Hook to manage dashboard cards with dynamic data
 * @param {Object} activeAccount - Current active MSAL account
 * @param {Object} user - Current user object with access rights
 * @param {Object} pageData - Page data containing counts
 * @param {Object} loading - Loading states for cards
 * @param {Object} errors - Per-section fetch error flags
 * @returns {Array} Enriched dashboard cards
 */
export const useDashboardCards = (activeAccount, user, pageData, loading, errors) => {
  return useMemo(() => {
    if (!activeAccount || !user?.accessRights) {
      return [];
    }

    const effectiveAccessRights = buildEffectiveAccessRights(
      user.accessRights,
      user.accessRights.admin
    );

    const cards = getDashboardCards(effectiveAccessRights);

    return enrichCardsWithData(cards, pageData, loading, errors);
  }, [activeAccount, user?.accessRights, pageData, loading, errors]);
};
